import React, { FC } from "react";
import { NavigationBarProps } from "./NavigationBar.types";
import styles from "./NavigationBar.module.scss";
import { Container } from "../index";

const NavigationBar: FC<NavigationBarProps> = ({ children, logo, avatar }) => {
  return (
    <Container>
      <div className={styles.NavigationBar} data-testid="NavigationBar">
        <img src={logo} alt={"Logo"} height={"30px"} />
        <div className={styles.tabsContainer}>{children}</div>

        <div className={styles.right}>{avatar}</div>
      </div>
    </Container>
  );
};

export default NavigationBar;
